import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { store } from "./app/store";
import { sessionSet } from "@features/auth/model/session-slice";
import { consumeSsoCallback, setSsoOutcome } from "@features/auth/lib/iam-sso";
import "./styles/globals.css";

// กลับมาจาก IAM พร้อม token ใน fragment — ต้องกินก่อน render
// ไม่งั้น request ชุดแรกของหน้าออกไปโดยไม่มี token แล้วได้ 401 มาแสดงแวบหนึ่ง
// (store ถูก import ไปแล้วตอนนี้ จึงต้อง dispatch เอง ไม่ใช่หวังให้ initialState อ่านเจอ)
const ssoOutcome = consumeSsoCallback();
setSsoOutcome(ssoOutcome);
if (ssoOutcome.kind === "ok") store.dispatch(sessionSet(ssoOutcome.session));

const el = document.getElementById("root");
if (!el) throw new Error("ไม่พบ #root ใน index.html");

createRoot(el).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// service worker = ที่ทำให้ติดตั้งลงหน้าจอ iPhone แล้วเปิดตอนออฟไลน์ได้
// (ของเดิมลงทะเบียนใน <script> ท้าย index.html)
if ("serviceWorker" in navigator) {
  addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
